document.addEventListener('DOMContentLoaded', () => {
  const feedbackEl = document.querySelector('.postfooter__rating');

  if (!feedbackEl) {
    return;
  }

  const feedbackBtns = feedbackEl.querySelectorAll('input[type="radio"]');

  function getCookie(name) {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const cookie = cookies.find(cookie => cookie.startsWith(`${name}=`));
    return cookie ? cookie.split('=')[1] : null;
  }

  function getFeedbackObject() {
    const feedbackCookie = getCookie('ecotelBlogFeedback');
    return feedbackCookie ? JSON.parse(feedbackCookie) : {};
  }

  function setFeedback(value) {
    const pageUid = feedbackEl.dataset.uid;
    const feedbackObject = getFeedbackObject();

    feedbackObject[pageUid] = value;

    document.cookie = `ecotelBlogFeedback=${JSON.stringify(feedbackObject)}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString()}; path=/`;
    feedbackEl.classList.add('has-value');
  }

  function loadFeedback() {
    const pageUid = feedbackEl.dataset.uid;
    const feedbackObject = getFeedbackObject();

    if (feedbackObject[pageUid]) {
      const input = feedbackEl.querySelector(`input[value="${feedbackObject[pageUid]}"]`);
      if (input) {
        input.checked = true;
      }
      feedbackEl.classList.add('has-value');
    }
  }

  if (feedbackBtns.length > 0) {
    loadFeedback();

    feedbackBtns.forEach(radio => {
      radio.addEventListener('change', () => {
        setFeedback(radio.value);
      });
    });
  }
});
